import { render, staticRenderFns } from "./kiosk-app.vue?vue&type=template&id=5f3069f3&"
import script from "./kiosk-app.vue?vue&type=script&lang=js&"
export * from "./kiosk-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports